import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from '../paths';
import { PageRoute } from '../types';

export const mediaPlansRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/media-plans/pages/MediaPlansPage')),
    path: ROUTES.AUTHORIZED.MEDIA_PLANS,
    title: 'Media Plans',
  },
  {
    component: asyncComponentLoader(() => import('@/features/media-plans/pages/MediaPlanPage')),
    path: `${ROUTES.AUTHORIZED.MEDIA_PLANS}/:id`,
    title: 'Media Plan',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/media-plans/pages/MediaPlanFormPage/MediaPlanFormPage'),
    ),
    path: `${ROUTES.AUTHORIZED.MEDIA_PLAN_FORM}/:id?`,
    title: 'Media Plan Form',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/media-plans/pages/MediaPlanPage/MediaPlanOrderSuccess'),
    ),
    path: `${ROUTES.AUTHORIZED.MEDIA_PLAN_ORDERED}/:id`,
    title: 'Media Plan Ordered',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/media-plans/pages/MediaPlanRemovePage'),
    ),
    path: `${ROUTES.AUTHORIZED.DELETE_MEDIA_PLAN}/:id`,
    title: 'Delete Media Plan',
  },
];
